<template>
  <p>
    From
    <strong class="text-purple-ap-100 uppercase font-black">{{
      birthCountry
    }}</strong>
  </p>
</template>

<script>
export default {
  name: "Nationality",
  props: ["birthCountry"],
};
</script>
